
<div v-if="is_aic_one_user()" id="aic_one_logo" >

    <div v-if="apex_domain" class="fab-container position-fixed  z-5" ref="fab_container" id="fabContainer"
    :style="{ left: fab_position.x + 'px', top: fab_position.y + 'px' }">
    <div class="fab-options position-absolute" :class="{ 'd-none': is_minimized }" id="fabOptions">

      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Proba analytics" @click="launch_platform('Proba_analytics')">
        <img :src="$probaanalytics" alt="Proba analytics" class="fab-icon-small h-100" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Complyon" @click="launch_platform('Complyon') ">
        <img :src="$Complyon" alt="Complyon" class="fab-icon-wide h-100" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="AI" @click="launch_platform('Home')">
        <img :src="$aicone" alt="Home" class="fab-icon-small h-100" />
      </a>
    </div>

    <button
      class="fab-main cursor-pointer position-relative rounded-circle border-0 d-flex align-items-center justify-content-center"
      @click="handle_fab_click" @touchend="handle_fab_click" id="fabMain">
      <img v-if="!is_minimized" :src="$Engage" alt="Open Menu" class="fab-main-icon h-75" />
      <i v-else class="bi bi-arrows-angle-expand fab-expand-icon text-white"></i>
    </button>
  </div>

  <div v-else class="fab-container position-fixed  z-5" ref="fab_container" id="fabContainer"
    :style="{ left: fab_position.x + 'px', top: fab_position.y + 'px' }">
    <div class="fab-options position-absolute" :class="{ 'd-none': is_minimized }" id="fabOptions">
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="AI" @click="launch_platform('Home')">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/aicone_logo_v3.webp" alt="Home" class="fab-icon-small h-100" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Proba analytics" @click="launch_platform('Proba_analytics')">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/proba.webp" alt="Proba analytics" class="fab-icon-small" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Complyon" @click="launch_platform('Complyon') ">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/complyon.webp" alt="Complyon" class="fab-icon-wide" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="complyon onboard" @click="launch_platform('complyon_onboard') ">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/onboarding.webp" alt="Complyon" class="fab-icon-wide" />
      </a>

      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="x-verdict" @click="launch_platform('x-verdict')">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/xverdict.webp" alt="X-verdict" class="fab-icon-small" />
      </a>

      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Proba workflows" @click="launch_platform('Proba_workflows')">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/proba.webp" alt="Proba Workflows" class="fab-icon-small" />
      </a>
      <a class="fab-option rounded-circle cursor-pointer my-2 position-absolute d-flex align-items-center justify-content-center"
        title="Orcaa" @click="launch_platform('Orcaa')">
        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/orcaa.webp" alt="Orcaa" class="fab-icon-small" />
      </a>
    </div>

    <button
      class="fab-main cursor-pointer position-relative rounded-circle border-0 d-flex align-items-center justify-content-center"
      @click="handle_fab_click" @touchend="handle_fab_click" id="fabMain">
      <img v-if="!is_minimized" src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/aicone.webp" alt="Open Menu" class="fab-main-icon h-75" />
      <i v-else class="bi bi-arrows-angle-expand fab-expand-icon text-white"></i>
    </button>
  </div>

</div>
